/**
 * An autogenerated component that renders the JUMP_INTO_NUMERATOR iconograpy in SVG.
 *
 * Generated with: https://gist.github.com/crm416/3c7abc88e520eaed72347af240b32590.
 */
var React = require('react');

var JumpIntoNumerator = function JumpIntoNumerator() {
  return React.createElement(
    "svg",
    { width: "48", height: "48", viewBox: "0 0 48 48" },
    React.createElement(
      "g",
      { fill: "none", fillRule: "evenodd" },
      React.createElement("path", { fill: "none", d: "M0 0h48v48H0z" }),
      React.createElement("path", { fill: "none", d: "M12 12h24v24H12z" }),
      React.createElement("path", { d: "M13 16v16M17 22l6-6M23 20v-4h-4", stroke: "#78C008", strokeWidth: "2", strokeLinecap: "round", strokeLinejoin: "round" }),
      React.createElement("path", { d: "M26 27.997c0-.55.453-.997.997-.997h6.006c.55 0 .997.453.997.997v6.006c0 .55-.453.997-.997.997h-6.006c-.55 0-.997-.453-.997-.997v-6.006zM28 29h4v4h-4v-4z", fill: "#888D93" }),
      React.createElement("path", { d: "M35 24H25", stroke: "#888D93", strokeWidth: "2", strokeLinecap: "round", strokeLinejoin: "round" }),
      React.createElement("path", { d: "M26 13.997c0-.55.453-.997.997-.997h6.006c.55 0 .997.453.997.997v6.006c0 .55-.453.997-.997.997h-6.006c-.55 0-.997-.453-.997-.997v-6.006zM28 15h4v4h-4v-4z", fill: "#78C008" })
    )
  );
};

module.exports = JumpIntoNumerator;


/*****************
 ** WEBPACK FOOTER
 ** ./math-input/src/components/iconography/jump-into-numerator.js
 ** module id = 615
 ** module chunks = 0 2
 **/